<!-- h -->
<template>
  <div>
    <el-button type="primary" @click="test" v-if="false">test</el-button>
    <el-checkbox v-model="stageListCheckAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange" class="chkAll">全选</el-checkbox>
    <div style="margin: 15px 0;"></div>
    <el-checkbox-group v-model="checkedWarehouseList" @change="handleCheckedItemChange">
      <el-checkbox v-for="item in warehouseList" :label="item.WarehouseName" :key="item.warehouseId" class="chkSize">{{item.WarehouseName}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
      },
      sourceData: [],

      warehouseList: [], // <!-- h -->
      checkedWarehouseList: [], // <!-- h -->
      stageListCheckAll: false, // <!-- h -->
      isIndeterminate: false, // <!-- h -->
    }
  },
  methods: {
    // <!-- h -->
    test() {
      
    },
    setData(allList, selList) {
      this.warehouseList = allList;
      while (this.checkedWarehouseList.length > 0) {
        this.checkedWarehouseList.pop();
      };
      selList.map(item => {
        this.checkedWarehouseList.push(item.WarehouseName);
      });        
      
      this.stageListCheckAll = selList.length === this.warehouseList.length;
      this.$set(this, "isIndeterminate", selList.length > 0 && selList.length < this.warehouseList.length);
      selList.map(item => {
        this.checkedWarehouseList.push(item.WarehouseName);
      });        
      
      this.stageListCheckAll = selList.length === this.warehouseList.length;
      this.$set(this, "isIndeterminate", selList.length > 0 && selList.length < this.warehouseList.length);
    },
    handleCheckAllChange(val) {
      var chkList = val === true ? [...this.warehouseList] : [];
          
      while (this.checkedWarehouseList.length > 0) {
        this.checkedWarehouseList.pop();
      }

      if (chkList.length > 0) {
        chkList.map(item => {
          this.checkedWarehouseList.push(item.WarehouseName);
        })
      }
      else {
        this.checkedWarehouseList = [];
      }

      this.isIndeterminate = false;
    },
    handleCheckedItemChange(value) {
      if (chkList.length > 0) {
        chkList.map(item => {
          this.checkedWarehouseList.push(item.WarehouseName);
        })
      }
      else {
        this.checkedWarehouseList = [];
      }

      this.isIndeterminate = false;
    },
    handleCheckedItemChange(value) {
      let checkedCount = value.length;
      this.stageListCheckAll = checkedCount === this.warehouseList.length;
      //this.isIndeterminate = checkedCount > 0 && checkedCount < this.warehouseList.length;
      this.$set(this, "isIndeterminate", checkedCount > 0 && checkedCount < this.warehouseList.length);
    },

    getChecked() {
      return this.checkedWarehouseList;
    },
    // <!-- h -->

  }
}
</script>
<style scoped>
._checkbox {
  margin-right: 10px;
}
.chkSize {
  width: 170px;
}
.chkAll {
  color: #bbb;
}
</style>